import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import configureStore, { history } from "./store";
import App from "./containers/App";
//import setAuthorizationToken from './util/setAuthorizationToken';
import { setCurrentUser  } from './actions/Auth';
import VersionCheck from './util/VersionCheck';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { toast } from 'react-toastify';
import {Button} from '@material-ui/core';
import CachedIcon from '@mui/icons-material/Cached';
import IntlMessages from 'util/IntlMessages';


export const queryClient = new QueryClient();

export const store = configureStore();

if (localStorage.token) {
  store.dispatch(setCurrentUser(localStorage.token));
}
//2022-09-27
if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
	console.error = () => {}
  console.debug = () => {}
}

const pushUpdateToast = ()=>{
	toast(<div className="d-flex align-items-center justify-content-between w-100" style={{gap: 5}}>
			<span style={{color:'#5e5e5e', fontWeight:'bold'}}><IntlMessages id="New.Update"/></span>
			<Button size="small" onClick={()=> {window.location.reload();}} variant="outlined" color="primary" style={{padding: '4px 18px'}} endIcon={<CachedIcon/>}><IntlMessages id="Update"/></Button>
		</div>, {
		position: "top-right",
			autoClose: false,
			closeButton: false,
			hideProgressBar: false,
			closeOnClick: false,
			pauseOnHover: true,
			draggable:false,
			
			// onOpen: () => this.setToasterTONull(this.props.authUser.user_id,notis.id)
	});
}

serviceWorkerRegistration.register({
	onUpdate: (registration) => {
		const waitingServiceWorker = registration.waiting;

		if (waitingServiceWorker) {
			waitingServiceWorker.addEventListener('statechange', (event) => {
				if (event.target.state === 'activated') {
					pushUpdateToast()
				}
			});
			waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
		}
	},
});

const MainApp = () =>{
  VersionCheck()
  return (
    <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App}/>
        </Switch>
      </ConnectedRouter>
    </Provider>
	</QueryClientProvider>
  )
}
 ;


export default (MainApp);